import { hideLoader } from "action/loader/hideLoader";
import { showLoader } from "action/loader/showLoader";
import { updateLayoutApi } from "../../api/product/updateLayoutApi";
import { setLayout } from "./setLayout";

export function updateLayout(layout: string) {
  return async (dispatch: any) => {
    dispatch(showLoader());
    await updateLayoutApi(layout);
    dispatch(setLayout(layout));
    dispatch(hideLoader());
  };
}
